module.exports = [
  {
    title: 'Справочники',
    state: 'NSI',
    permission: 'nsi',
    icon: require('@/assets/icons/NSI.png')
  },
  {
    title: 'Журналы',
    state: 'RequestLogs',
    permission: 'monitoring',
    icon: require('@/assets/icons/RequestLogs.png')
  },
  {
    title: 'Настройки',
    state: 'Settings',
    permission: 'settings',
    icon: require('@/assets/icons/Settings.png')
  },
  {
    title: 'Учетные записи',
    state: 'Users',
    permission: 'users',
    icon: require('@/assets/icons/Users.png')
  },
  {
    title: 'Aдминистративные панели сервисов',
    state: 'AdminPannel',
    permission: 'settings',
    icon: require('@/assets/icons/Settings.png')
  },
]
